import { render, staticRenderFns } from "./iconNoDeposits.vue?vue&type=template&id=0ba7d8fa"
import script from "./iconNoDeposits.vue?vue&type=script&lang=js"
export * from "./iconNoDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports